import template from "./templates/datapoint/template.html";
import { datapointAddOn } from "./templates/datapoint/datapoint-add-on.js";
import datapointController from "./templates/datapoint/controller.js";

export default angular
	.module("vesl.extensions.json-schema.datapoint", [
		"schemaForm",
		datapointController
	])
	.run(["$templateCache", function($templateCache) { $templateCache.put("./templates/datapoint/template.html", template); }])
	.config(datapointAddOn)
	.name;
